import React from "react";
import { useHistory } from "react-router-dom";
import "./WhyChooseUs.css";

/* ── icons (white line icons, sit inside the orange circle) ── */
const Ic = {
  product: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      <polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
  ),
  support: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
      <path d="M18 19a2 2 0 0 1-2 2h-2" />
      <rect x="2" y="13" width="4" height="6" rx="1" /><rect x="18" y="13" width="4" height="6" rx="1" />
      <circle cx="12" cy="9" r="2.4" />
    </svg>
  ),
  trading: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 16 9 10 13 14 21 6" /><polyline points="15 6 21 6 21 12" />
      <line x1="3" y1="20" x2="21" y2="20" />
    </svg>
  ),
  execution: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 16a8 8 0 1 1 16 0" /><line x1="12" y1="16" x2="15.5" y2="11.5" /><circle cx="12" cy="16" r="1.2" fill="currentColor" stroke="none" />
    </svg>
  ),
  liquidity: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" />
      <polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
    </svg>
  ),
  cost: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="19" y1="5" x2="5" y2="19" /><circle cx="6.5" cy="6.5" r="2.5" /><circle cx="17.5" cy="17.5" r="2.5" />
    </svg>
  ),
};

/* 🔧 edit cards / links here */
const CARDS = [
  { icon: Ic.product,   title: "Diverse Product Suite",   text: "Access a wide range of investment and trading solutions including Equities, Futures, Options, Mutual Funds, and more.", link: "/product-and-services" },
  { icon: Ic.support,   title: "Exceptional Support",     text: "Live market updates, research reports, and dedicated support to help you make informed investment decisions.", link: "/contact-us" },
  { icon: Ic.trading,   title: "Powerful Trading",        text: "Leverage advanced platforms, margin facilities, and innovative tools to maximize your potential returns with confidence.", link: "/about-online-trading" },
  { icon: Ic.execution, title: "Fast Market Execution",   text: "Experience swift and reliable trade execution with zero delays, backed by cutting-edge technology and expert risk management.", link: "/about-online-trading" },
  { icon: Ic.liquidity, title: "High Liquidity",          text: "Enjoy high market liquidity with seamless transactions and quick fund transfers.", link: "/market-overview" },
  { icon: Ic.cost,      title: "Cost-Effective Brokerage", text: "Benefit from competitive brokerage rates and transparent pricing with no hidden charges.", link: "/commision-structure" },
];

const Arrow = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
  </svg>
);

const WhyChooseUs = () => {
  const history = useHistory();
  const go = (link) => {
    if (!link) return;
    if (/^https?:\/\//i.test(link)) window.open(link, "_blank", "noopener");
    else history.push(link);
  };

  return (
    <section className="wcu">
      <div className="wcu-inner">
        <div className="wcu-eyebrow"><span className="wcu-dash" />WHY CHOOSE ORBIT SECURITIES<span className="wcu-dash" /></div>
        <h2 className="wcu-title">WHY CHOOSE <span>US?</span></h2>
        <span className="wcu-title-underline" />
        <p className="wcu-sub">
          Get instant access to the best tools and advice to maximize your investments.
          We ensure the <span className="hl">ultimate safety</span> of client funds while <span className="hl">enhancing profitability</span>.
        </p>

        <div className="wcu-grid">
          {CARDS.map((c, i) => (
            <div className="wcu-card" key={i}>
              <div className="wcu-ic">{c.icon}</div>
              <h3 className="wcu-card-title">{c.title}</h3>
              <span className="wcu-card-underline" />
              <p className="wcu-card-text">{c.text}</p>
              <button className="wcu-more" onClick={() => go(c.link)}>
                Learn More <Arrow />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
